import React from "react";
import "../../pages/reports/gce-o.css";
import { ExamType } from "../../types/types";

interface SubjectData {
  code: string;
  name: string;
  student_count: string | number;
}

interface PROBProps {
  registrationData: {
    exam_registration?: {
      subject_categories?: Record<string, SubjectData[]>;
    } | null;
  } | null;
  selectedExamTypes: ExamType[];
}

const PROB: React.FC<PROBProps> = ({ registrationData, selectedExamTypes }) => {
  const shouldRenderTables = selectedExamTypes.some((et) =>
    et.name.includes("PROB")
  ); // Use .some() instead of finding the exact one and checking

  if (!shouldRenderTables) return null;

  const categories = ["PROBA4", "PROBBIL", "PROBC", "PROBD", "PROBTI"];
  const categoryKeys: Record<string, string> = {
    PROBA4: "A4",
    PROBBIL: "BIL",
    PROBC: "C",
    PROBD: "D",
    PROBTI: "TI",
  };
  const subjectCategories =
    registrationData?.exam_registration?.subject_categories || {};

  const subjectMap = new Map<
    string,
    { name: string; counts: Record<string, number> }
  >();
  for (const cat of categories) {
    const subjects = subjectCategories[cat] || [];
    for (const subj of subjects) {
      if (!subjectMap.has(subj.code)) {
        subjectMap.set(subj.code, { name: subj.name, counts: {} });
      }
      subjectMap.get(subj.code)!.counts[categoryKeys[cat]] =
        Number(subj.student_count) || 0;
    }
  }

  const presenceMap = new Map<string, Set<string>>();
  for (const [code, data] of subjectMap) {
    const presentIn = new Set(Object.keys(data.counts));
    presenceMap.set(code, presentIn);
  }

  const groups: { subjects: string[] }[] = [
    { subjects: [] }, // all five
    { subjects: [] }, // C, D, TI only
    { subjects: [] }, // A4 & BIL only
    { subjects: [] }, // C & D only
    { subjects: [] }, // unique A4
    { subjects: [] }, // unique BIL
    { subjects: [] }, // unique C
    { subjects: [] }, // unique D
    { subjects: [] }, // unique TI
  ];

  for (const [code, presentIn] of presenceMap) {
    if (presentIn.size === 5) {
      groups[0].subjects.push(code);
    } else if (
      presentIn.has("C") &&
      presentIn.has("D") &&
      presentIn.has("TI") &&
      !presentIn.has("A4") &&
      !presentIn.has("BIL")
    ) {
      groups[1].subjects.push(code);
    } else if (
      presentIn.has("A4") &&
      presentIn.has("BIL") &&
      !presentIn.has("C") &&
      !presentIn.has("D") &&
      !presentIn.has("TI")
    ) {
      groups[2].subjects.push(code);
    } else if (
      presentIn.has("C") &&
      presentIn.has("D") &&
      !presentIn.has("A4") &&
      !presentIn.has("BIL") &&
      !presentIn.has("TI")
    ) {
      groups[3].subjects.push(code);
    } else if (presentIn.size === 1) {
      const cat = Array.from(presentIn)[0];
      if (cat === "A4") groups[4].subjects.push(code);
      else if (cat === "BIL") groups[5].subjects.push(code);
      else if (cat === "C") groups[6].subjects.push(code);
      else if (cat === "D") groups[7].subjects.push(code);
      else if (cat === "TI") groups[8].subjects.push(code);
    }
  }

  const renderRows = () => {
    const rows: React.JSX.Element[] = [];
    for (const group of groups) {
      for (const code of group.subjects) {
        const subj = subjectMap.get(code)!;
        rows.push(
          <tr key={code} style={{ fontSize: "8px", lineHeight: "6px" }}>
            <td colSpan={2}>
              {code} {subj.name}
            </td>
            <td>{subj.counts.A4 ?? "N/A"}</td>
            <td>{subj.counts.BIL ?? "N/A"}</td>
            <td>{subj.counts.C ?? "N/A"}</td>
            <td>{subj.counts.D ?? "N/A"}</td>
            <td>{subj.counts.TI ?? "N/A"}</td>
          </tr>
        );
      }
    }
    return rows;
  };

  return (
    <table className="gceo-subjects-table">
      <tbody>
        <tr>
          <th colSpan={2}>MATIERES / SERIES</th>
          <th># of Candidates A4</th>
          <th># of Candidates BIL</th>
          <th># of Candidates C</th>
          <th># of Candidates D</th>
          <th># of Candidates TI</th>
        </tr>
        {renderRows()}
      </tbody>
    </table>
  );
};

export default PROB;
